import type { CatalogEntry } from './types';

/**
 * Cross-cutting reserved codes (feature `00`), used by the global exception
 * filter as fallbacks when an error cannot be attributed to an authored code.
 */
export const RESERVED = {
  /** Unhandled / unexpected error (500 fallback). Real stack logged server-side. */
  UNHANDLED: '000000',
  /** Uncategorized validation failure (filter could not attribute a feature). */
  VALIDATION: '000001',
} as const;

export const RESERVED_CATALOG: Record<string, CatalogEntry> = {
  [RESERVED.UNHANDLED]: {
    httpStatus: 500,
    message: 'Something went wrong on our end. Please try again.',
  },
  [RESERVED.VALIDATION]: {
    httpStatus: 400,
    message: "Some of the information you entered isn't valid. Please check and try again.",
  },
};
